module.exports = __webpack_public_path__ + "img/70200.d7f6c7cf.jpg";